// extracted by mini-css-extract-plugin
module.exports = {"pill":"CountPill_pill__bP_EG","accent":"CountPill_accent__PPFNo","neutral":"CountPill_neutral__2IeNg"};